import { AppRoutes } from "../../enums";

type ChunkLoader = () => Promise<unknown>;

/** The admin shell around every section (main-app-routing.module.ts is the router's copy of these imports). */
export const loadMainAppChunk: ChunkLoader = () => import("../../pages/main-app/main-app.module");

/** The lazy section the first navigation opens, by the URL segment after the program slug. */
export const ENTRY_ROUTE_CHUNKS: Partial<Record<string, ChunkLoader>> = {
  [AppRoutes.home]: () => import("../../pages/home/home.module"),
  [AppRoutes.customize]: () => import("../../pages/design/design.module"),
  [AppRoutes.design]: () => import("../../pages/design/design.module"),
  [AppRoutes.campaigns]: () => import("../../pages/campaigns/campaigns.module"),
  [AppRoutes.loyalty]: () => import("../../pages/loyalty/loyalty.module"),
  [AppRoutes.engagement]: () => import("../../pages/engagement/engagement.module"),
  [AppRoutes.analytics]: () => import("../../pages/analytics/analytics.module"),
  [AppRoutes.customers]: () => import("../../pages/customers/customers.module"),
  [AppRoutes.settings]: () => import("../../pages/settings/settings.module"),
};

/**
 * Starts downloading the chunks of the page the app is about to open while the session starts (App Bridge token,
 * language file, program), instead of after it: the router only asks for them on its first navigation, and each
 * level (shell, section) would otherwise be one more round trip before the first paint. The router reuses the same
 * modules, so nothing loads twice; a failed download is left for the router to retry and report.
 */
export function prefetchEntryRoute(url: string, programSlug: string, chunks = ENTRY_ROUTE_CHUNKS, mainApp = loadMainAppChunk): void {
  const fragments = url.split(/[?#]/)[0].split("/").filter(Boolean);
  const [section] = fragments[0] === programSlug ? fragments.slice(1) : fragments;
  // The program root opens the shell's default page (main-app-routing.module.ts "**")
  const loadSection = section ? chunks[section] : chunks[AppRoutes.customize];
  if (!loadSection) return;

  mainApp().catch(() => null);
  loadSection().catch(() => null);
}
